@if (label || helpText) {
  <div class="mb-2 flex items-center gap-1">
    @if (label) {
      <mat-label class="text-sm font-medium">{{ label }}</mat-label>
    }
    @if (helpText) {
      <mat-icon
        class="material-icons-outlined hvs-icon-base cursor-help"
        [matTooltip]="helpText"
        matTooltipPosition="above"
        matTooltipClass="tooltip-above"
        >help_outline</mat-icon
      >
    }
  </div>
}
<mat-form-field
  *transloco="let t"
  class="input_field__form_field w-full"
  appearance="outline"
  [subscriptSizing]="bottomMargin ? 'fixed' : 'dynamic'"
>
  @if (icon) {
    <mat-icon matIconPrefix>{{ icon }}</mat-icon>
  }
  <input
    [id]="id"
    matInput
    class="input_field__input"
    [type]="type"
    [formControl]="control"
    [placeholder]="placeholder"
    [errorStateMatcher]="errorStateMatcher"
  />
  @if (control.invalid && errorMessage() && !hideErrors) {
    <mat-error class="text-sm">
      {{ t('general.inputValidation.' + errorMessage()) }}
    </mat-error>
  }
</mat-form-field>
